import { useSelector } from 'react-redux';
import { UserProfile } from 'types';
import { AdminRole } from '@trnsact/trnsact-shared-types';
import { useQuery } from '@apollo/client';
import { broadcastApi } from '../api';

export function useBroadcastsTableData() {
  const userProfile = useSelector((state: any) => state.userProfile) as UserProfile;

  const { data: accountOwnedBroadcastsData, loading: accountOwnedBroadcastsLoading } = useQuery(
    broadcastApi.getAccountOwnedBroadcasts
  );

  const { data: globalBroadcastsData, loading: globalBroadcastsLoading } = useQuery(broadcastApi.getGlobalBroadcasts, {
    skip: userProfile.adminRole !== AdminRole.Super,
  });

  const broadcasts = [
    ...(accountOwnedBroadcastsData?.broadcast?.accountOwnedBroadcasts ?? []),
    ...(globalBroadcastsData?.broadcast?.globalBroadcasts ?? []),
  ].sort((a, b) => new Date(b.effectiveDateTime).getTime() - new Date(a.effectiveDateTime).getTime());

  return {
    loading: accountOwnedBroadcastsLoading || globalBroadcastsLoading,
    broadcasts,
  };
}
